<script>
export default {
  name: 'VectorGraph',
  props: ['stableData'],
  data () {
    return {
      points1: '150,150 300,150 275,125 300,150 275,175',
      points2: '',
      points3: '',
      textPosition: [{}],
      // 电气量下拉框
      posSelectOptions: [{
        value: 1,
        label: '电压'
      }, {
        value: 2,
        label: '电流'
      }],
      posSelectValue: 1,
      lineProp: 1
    }
  },
  watch: {
    stableData () {
      this.set_line()
    },
    posSelectValue () {
      this.set_line()
    }
  },
  computed: {
    u_level () {
      if (this.stableData && this.stableData.ua_rms > 1000 && this.stableData.ub_rms > 1000 && this.stableData.uc_rms > 1000) {
        return true
      } else {
        return false
      }
    },
    i_level () {
      if (this.stableData && this.stableData.ia_rms > 1000 && this.stableData.ib_rms > 1000 && this.stableData.ic_rms > 1000) {
        return true
      } else {
        return false
      }
    }
  },
  beforeMount () {
    this.vecTextPosition()
  },
  mounted () {
    this.points1 = this.line_change(this.stableData ? this.stableData.theta_ua : 0, this.stableData ? this.stableData.ua_rms : 0)
    this.points2 = this.line_change(this.stableData ? this.stableData.theta_ub : 0, this.stableData ? this.stableData.ub_rms : 0)
    this.points3 = this.line_change(this.stableData ? this.stableData.theta_uc : 0, this.stableData ? this.stableData.uc_rms : 0)

    this.set_line()
  },
  methods: {
    line_change (theta, r) {
      var linePoint = []
      var ArrowOffsetX = -10
      var BaseY1 = 5
      var BaseY2 = -5

      var cosfi = Math.cos(theta * 0.0174532925199)
      var sinfi = Math.sin(theta * 0.0174532925199)

      var x = r * cosfi
      var y = r * sinfi

      var x1 = Math.round((ArrowOffsetX + r) * cosfi - BaseY1 * sinfi)
      var y1 = Math.round(BaseY1 * cosfi + (ArrowOffsetX + r) * sinfi)

      var x2 = Math.round((ArrowOffsetX + r) * cosfi - BaseY2 * sinfi)
      var y2 = Math.round(BaseY2 * cosfi + (ArrowOffsetX + r) * sinfi)

      let pointItem = {}
      pointItem.x = x + 190
      pointItem.y = 210 - y
      linePoint[1] = pointItem

      pointItem = {}
      pointItem.x = x1 + 190
      pointItem.y = 210 - y1
      linePoint[2] = pointItem

      pointItem = {}
      pointItem.x = linePoint[1].x
      pointItem.y = linePoint[1].y
      linePoint[3] = pointItem

      pointItem = {}
      pointItem.x = x2 + 190
      pointItem.y = 210 - y2
      linePoint[4] = pointItem

      // pointItem = {}
      // pointItem.x = linePoint[1].x
      // pointItem.y = linePoint[1].y
      linePoint[5] = linePoint[1]

      return '190,210 ' + linePoint[1].x + ',' + linePoint[1].y + ' ' + linePoint[2].x + ',' + linePoint[2].y + ' ' + linePoint[3].x + ',' + linePoint[3].y + ' ' + linePoint[4].x + ',' + linePoint[4].y + ' ' + linePoint[5].x + ',' + linePoint[5].y + ' '
    },

    vecTextPosition () {
      var position = []

      for (var i = 0; i < 12; ++i) {
        let positionItem = {}
        var x = 180 * Math.cos((i * 30) * 3.14 / 180) + 0 * Math.sin((i * 30) * 3.14 / 180)
        var y = 0 * Math.cos((i * 30) * 3.14 / 180) - 180 * Math.sin((i * 30) * 3.14 / 180)

        positionItem.x = x + 178
        positionItem.y = y + 220
        position[i] = positionItem
        // console.log(positionItem.x, positionItem.y)
      }
      this.textPosition = position
    },
    set_line () {
      var max = 0
      if (this.posSelectValue === 1) {
        if (max < this.stableData.ua_rms) {
          max = this.stableData.ua_rms
        }
        if (max < this.stableData.ub_rms) {
          max = this.stableData.ub_rms
        }
        if (max < this.stableData.uc_rms) {
          max = this.stableData.uc_rms
        }
        this.lineProp = 150 / max
        this.points1 = this.line_change(this.stableData.theta_ua, this.lineProp * this.stableData.ua_rms)
        this.points2 = this.line_change(this.stableData.theta_ub, this.lineProp * this.stableData.ub_rms)
        this.points3 = this.line_change(this.stableData.theta_uc, this.lineProp * this.stableData.uc_rms)
      } else if (this.posSelectValue === 2) {
        if (max < this.stableData.ia_rms) {
          max = this.stableData.ia_rms
        }
        if (max < this.stableData.ib_rms) {
          max = this.stableData.ib_rms
        }
        if (max < this.stableData.ic_rms) {
          max = this.stableData.ic_rms
        }
        this.lineProp = 150 / max
        console.log(this.lineProp)
        this.points1 = this.line_change(this.stableData.theta_ia, this.lineProp * this.stableData.ia_rms)
        this.points2 = this.line_change(this.stableData.theta_ib, this.lineProp * this.stableData.ib_rms)
        this.points3 = this.line_change(this.stableData.theta_ic, this.lineProp * this.stableData.ic_rms)
      }
    }
  }
}
</script>

<template>
  <div class="pg" style="height: 65%">
<!--  <div class="pg" style="height: 520px; width: 800px">-->
    <div class="dataItems">
      <div class="title">相位角矢量图</div>
      <div class="dataItem">
        <div style="width: 55%; height: 100%; margin-left: 20px">

          <div style="width: 100%; display: flex; height: 35px; line-height: 35px;">
            <div
              style="width: 100%; display: flex; align-items: center; margin-left: 20px;">
              <div style="width: 100px">电气量选择</div>
              <div style="width: 150px; margin-left: 20px">
                <el-select v-model="posSelectValue" placeholder="请选择">
                  <el-option
                    v-for="item in posSelectOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <svg style="width: 100%; height: 100%">
            <circle cx="190" cy="210" r="155" stroke="#7E7E7EFF" stroke-width="1" fill="white"/>
            <circle cx="190" cy="210" r="150" stroke="#7E7E7EFF" stroke-width="1" fill="white"/>
            <!--            <line x1="150" y1="150" x2="300" y2="150" style="stroke:rgb(255,0,0);stroke-width:1" />-->
            <polyline :points="points1" style="fill:none;stroke:orange;stroke-width:1"/>
            <polyline :points="points2" style="fill:none;stroke:green;stroke-width:1"/>
            <polyline :points="points3" style="fill:none;stroke:red;stroke-width:1"/>

            <text :x="textPosition[0].x" :y="textPosition[0].y" fill="#7E7E7EFF">0</text>
            <text :x="textPosition[1].x" :y="textPosition[1].y" fill="#7E7E7EFF">30</text>
            <text :x="textPosition[2].x" :y="textPosition[2].y" fill="#7E7E7EFF">60</text>
            <text :x="textPosition[3].x" :y="textPosition[3].y" fill="#7E7E7EFF">90</text>
            <text :x="textPosition[4].x" :y="textPosition[4].y" fill="#7E7E7EFF">120</text>
            <text :x="textPosition[5].x" :y="textPosition[5].y" fill="#7E7E7EFF">150</text>
            <text :x="textPosition[6].x" :y="textPosition[6].y" fill="#7E7E7EFF">180</text>
            <text :x="textPosition[7].x" :y="textPosition[7].y" fill="#7E7E7EFF">210</text>
            <text :x="textPosition[8].x" :y="textPosition[8].y" fill="#7E7E7EFF">240</text>
            <text :x="textPosition[9].x" :y="textPosition[9].y" fill="#7E7E7EFF">270</text>
            <text :x="textPosition[10].x" :y="textPosition[10].y" fill="#7E7E7EFF">300</text>
            <text :x="textPosition[11].x" :y="textPosition[11].y" fill="#7E7E7EFF">330</text>
          </svg>
        </div>
        <div class="dataName">
          <div class="dataTitle"></div>
          <div class="dataNvItem">Ua</div>
          <div class="dataNvItem">Ub</div>
          <div class="dataNvItem">Uc</div>
          <div class="dataNvItem">Ia</div>
          <div class="dataNvItem">Ib</div>
          <div class="dataNvItem">Ic</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">
            <div>有效值</div>
          </div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ua_rms : 0) / (u_level ? 1000 : 1)).toFixed(1) }}{{ u_level?"kV":"V" }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ub_rms : 0) / (u_level ? 1000 : 1)).toFixed(1) }}{{ u_level?"kV":"V" }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.uc_rms : 0) / (u_level ? 1000 : 1)).toFixed(1) }}{{ u_level?"kV":"V" }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ia_rms : 0) / (i_level ? 1000 : 1)).toFixed(1) }}{{ i_level?"kA":"A" }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ib_rms : 0) / (i_level ? 1000 : 1)).toFixed(1) }}{{ i_level?"kA":"A" }}</div>
          <div class="dataNvItem">{{ (Number(stableData ? stableData.ic_rms : 0) / (i_level ? 1000 : 1)).toFixed(1) }}{{ i_level?"kA":"A" }}</div>
        </div>
        <div class="dataValue">
          <div class="dataTitle">
            <div>相位角</div>
          </div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_ua : 0).toFixed(1) }}°</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_ub : 0).toFixed(1) }}°</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_uc : 0).toFixed(1) }}°</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_ia : 0).toFixed(1) }}°</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_ib : 0).toFixed(1) }}°</div>
          <div class="dataNvItem">{{ Number(stableData ? stableData.theta_ic : 0).toFixed(1) }}°</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

</style>



// WEBPACK FOOTER //
// src/pages/Stable/VectorGraph/VectorGraph.vue